export class LoginCredentials {
    public username: string;
    public password: string;
}